<script setup>
const props = defineProps({
  depth: {type: Number, default: 0},
  border: {type: Boolean, default: false}
});
</script>
<script>
export default {
  name: "DpSection"
}
</script>

<template>
  <div class="dp-nest" :class="[`depth-${props.depth}`, {'outlined': props.border}]">
    <slot></slot>
  </div>
</template>

<style lang="scss">
</style>
